import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Calendar from "react-calendar";

import "react-calendar/dist/Calendar.css";
import "./style.scss";
import moment from "moment";

const propTypes = {
  filter: PropTypes.func,
  setCategory: PropTypes.func,
  setDate: PropTypes.func,
  setKeyword: PropTypes.func,
  setPriceRange: PropTypes.func,
  category: PropTypes.string,
  date: PropTypes.string,
  keyword: PropTypes.string,
  priceRange: PropTypes.string,
};

const Filter = ({
  filter,
  priceRange,
  setPriceRange,
  category,
  setDate,
  date,
  setKeyword,
  keyword,
  setCategory,
}) => {
  const { t } = useTranslation();

  const [showCalendar, setShowCalendar] = useState(false);

  const onChange = (date) => {
    setDate(date);
    setShowCalendar(false);
  };

  const categories = [
    {
      value: "all",
      title: "all_categories",
    },
    {
      value: "0",
      title: "accommodation",
    },
    {
      value: "1",
      title: "activity",
    },
    {
      value: "2",
      title: "restaurant",
    },
    {
      value: "3",
      title: "shopping",
    },
  ];

  const priceRanges = [
    {
      value: "1-9999",
      title: "~ 9.999円",
    },
    {
      value: "10000-14999",
      title: "10.000円 ~ 14.999円",
    },
    {
      value: "15000-19999",
      title: "15.000円 ~ 19.999円",
    },
    {
      value: "20000-",
      title: " 20.000円 ~",
    },
  ];

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      date: event.target[0].value ? new Date(event.target[0].value) : null,
      category: category,
      minRange: priceRange?.includes("-") ? priceRange?.split("-")[0] : null,
      maxRange:
        priceRange?.split("-")[1] && priceRange?.includes("-")
          ? priceRange?.split("-")[1]
          : null,
      keyword: keyword,
    };
    setShowCalendar(false);
    filter(data);
  };

  const minDate = () => {
    const someDate = new Date();
    const numberOfDaysToAdd = 2;
    const result = someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
    return new Date(result);
  };
  return (
    <div className="filterWrapper">
      <form onSubmit={handleSubmit}>
        <Row>
          <div className="col-6 col-lg">
            <Form.Control
              type="input"
              name="date"
              placeholder={t("date_placeholder")}
              readOnly
              value={date && moment(date).format("LL")}
              onClick={() => setShowCalendar(!showCalendar)}
            />
            <Calendar
              minDate={minDate()}
              onChange={(date) => onChange(date)}
              value={date}
              className={!showCalendar ? "hide" : ""}
            />
            <small className="clearDate mt-1" onClick={() => setDate("")}>
              <a href="#">{t("clear_date")}</a>
            </small>
          </div>
          <div className="col-6 col-lg">
            <Form.Select
              type="text"
              name="price_range"
              onChange={(e) => setCategory(e.target.value)}
              value={category}
            >
              {categories.map((item, i) => {
                return (
                  <option key={i} value={item.value}>
                    {t(item.title)}
                  </option>
                );
              })}
            </Form.Select>
          </div>
          <div className="col-6 col-lg">
            <Form.Select
              type="text"
              name="price_range"
              onChange={(e) => setPriceRange(e.target.value)}
              value={priceRange}
            >
              <option value="0-">{t("price_range")}</option>
              {priceRanges.map((item, i) => {
                return (
                  <option key={i} value={item.value}>
                    {item.title}
                  </option>
                );
              })}
            </Form.Select>
          </div>
          <div className="col-6 col-lg">
            <Form.Control
              type="text"
              name="keyword"
              onChange={(e) => setKeyword(e.target.value)}
              placeholder={t("keyword")}
              value={keyword}
            />
          </div>
          <div className="col-12 col-lg onWrapper mt-3 mt-lg-0">
            <Button variant="primary" type="submit" className="w-100">
              {t("search")}
            </Button>
          </div>
        </Row>
      </form>
    </div>
  );
};

Filter.propTypes = propTypes;

export default Filter;
